import { breadthFirstSearch, traverseTree } from './search'
import Vue from 'vue'
import store from './../../store'
import api_catcher from '../../api/api_catcher.js'

export const createComponentInstance = function (importedComponent, preventApi, props) {
    const componentCtor = Vue.extend(importedComponent)
    // /* eslint-disable no-new */

    // Remove all watchers and lifecycle hooks to prevent accidental side
    // effect of the components hitting the API before it has been replaced by
    // the api_catcher
    const catchFunction = function () {}

    var previous = {
        ...componentCtor.options
    }

    componentCtor.options = {
        ...componentCtor.options,
        watch: {},
        mounted: catchFunction,
        created: catchFunction,
        //beforeCreate: catchFunction, // commented due to causing null pointer exception
        activated: catchFunction,
        beforeMount: catchFunction
    }

    let instance = new componentCtor({
        store: store,
        propsData: props
    })

    componentCtor.options = {
        ...previous
    }

    if (preventApi) {
        instance.$api = api_catcher
    }

    try {
        instance.$mount()
        if (preventApi) {
            traverseTree(
                instance,
                (component) => component.$children,
                (child) => {
                    child.$api = api_catcher
                }
            )
        }
    } catch (error) {}

    return instance
}

export const findComponent = function (rootInstance, componentName) {
    return breadthFirstSearch(
        rootInstance,
        (component) => component.$children,
        createPredicate(componentName)
    )
}

export const findClosestParent = function (rootInstance, componentName) {
    return breadthFirstSearch(
        rootInstance.$parent,
        (component) => component.$parent,
        createPredicate(componentName)
    )
}

function createPredicate(componentName) {
    var predicate = () => true
    var type = typeof componentName
    if (type === 'string') {
        predicate = function (child) {
            return child.$vnode && child.$vnode.componentOptions.tag == componentName
        }
    } else if (type === 'function') {
        predicate = componentName
    } else {
        throw 'Second argument must be a string or function'
    }
    return predicate
}

export default {
    createComponentInstance,
    findComponent,
    findClosestParent
}
